<template>
  <div class="footerV1-wrap section-gap" style="padding:1rem 0;">
    <v-container grid-list-xl py-0>
      <div class="footer-top">
        <v-layout row wrap>
          <v-flex xs12 sm12 md4 lg5 xl5>
            <div class="about-wrap">
              <h6 class="white--text mb-6">{{footerSection.Title}}</h6>
              <span class="white--text" v-html="footerSection.Description"></span>
            </div>
          </v-flex>
          <v-flex xs12 sm3 md2 lg2 xl2>
            <h6 class="white--text mb-4">{{footerSection.About_Title}}</h6>
            <div class="abt-menu">
              <ul class="list-unstyled pl-0">
                <li v-for="(list,key) in footerSection.About_List" :key="key">
                  <router-link :to="list.Path">{{(list.Name)}}</router-link>
                </li>
              </ul>
            </div>
          </v-flex>
          <!-- <v-flex xs12 sm3 md2 lg2 xl2>
						<h6 class="white--text mb-4">{{footerSection.Session_Title}}</h6>
						<div class="features-menu">
							<ul class="list-unstyled pl-0">
								<li 
									v-for="(list,key) in footerSection.Session_List"
									:key="key"
								>
									<router-link :to="list.Path">{{(list.Name)}}</router-link>
								</li>		
							</ul>
						</div>
          </v-flex>-->
          <!-- <v-flex xs12 sm3 md2 lg2 xl>
            <h6 class="white--text mb-4">{{footerSection.Category_Title}}</h6>
            <div class="policy-menu">
              <ul class="list-unstyled pl-0">
                <li v-for="(list,key) in footerSection.Category_List" :key="key">
                  <router-link :to="list.Path">{{(list.Name)}}</router-link>
                </li>
              </ul>
            </div>
          </v-flex>-->
          <v-flex xs12 sm3 md2 lg1 xl1>
            <div class="policy-menu">
              <h6 class="white--text mb-4">{{footerSection.Social_Media_Title}}</h6>
              <ul class="list-unstyled pl-0">
                <li v-for="(list,key) in footerSection.Social_Media_List" :key="key">
                  <a target="_blank" :href="list.Url">
                    <i :class="list.Fa_Icon +' contact_icon'" style="pointer:cursor"></i>{{list.Name}}
                  </a>
                </li>
              </ul>
            </div>
          </v-flex>
          <v-flex xs12 sm3 md2>
            <div class="cont-menu">
              <h6 class="white--text mb-4">{{ContactSection.Contact_Title}}</h6>
              <ul class="list-unstyled pl-0">
                <li>
                  <a>
                    <i class="fa fa-map-marker contact_icon"></i>{{ContactSection.Address}}
                  </a>
                   </li>
                   <li>
                  <a>
                     <i class="fa fa-phone contact_icon"></i>{{ContactSection.Phone_Number}}
                  </a>
                  </li>
                    <li>
                  <a>
                    <i class="fa fa-envelope contact_icon"></i>{{ContactSection.Email}}
                  </a>
                  </li>
               
              </ul>
            </div>
          </v-flex>
        </v-layout>
      </div>
      <hr />
      <div class="footer-bottom">
        <div class="footer-bottom-content px-3">
          <v-layout row wrap align-center justify-space-between>
            <v-flex xs12 sm12 md6 lg6 xl6 class="text-md-left text-center">
              <img :src="footerBottomSection.Payment_Image_218x18_px" width="218" height="18" />
            </v-flex>
            <v-flex xs12 sm12 md6 lg6 xl6 py-3 px-2>
              <div class="text-md-right text-center">
                <span class="white--text">{{footerBottomSection.Copyright_Label}}</span>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import gettingRestClientObject from "../../../../services/utils/cms-helper";
export default {
  props: ["title", "description", "img"],
  data() {
    return {
      cmsRequestFunctions: null,
      footerSection: "",
      footerBottomSection: "",
      ContactSection:{}
    };
  },
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
    this.getPageData();
  },
  computed: {
    ...mapGetters(["selectedLocale"]),
  },
  watch: {
    selectedLocale: function () {
      this.getPageData();
    },
  },
  methods: {
    getPageData: function () {
      var self = this;

      var language = localStorage.Language ? localStorage.Language : "en";

      var config = {
        pageType: "Template/",
        pageUrl: "03 Footer/03 Footer/03 Footer.ftl",
        lang: language,

        successCallback: function (response) {
          var res = response.data;
          if (res.area_List) {
            var footerArea = self.cmsRequestFunctions.pluck(
              "Footer_Section",
              res.area_List
            );
            self.footerSection = self.cmsRequestFunctions.getAllMapData(
              footerArea[0].component
            );
            var footerBottomArea = self.cmsRequestFunctions.pluck(
              "Footer_Bottom_Section",
              res.area_List
            );
            self.footerBottomSection = self.cmsRequestFunctions.getAllMapData(
              footerBottomArea[0].component
            );
            var contactArea = self.cmsRequestFunctions.pluck(
              "Contact_Section",
              res.area_List
            );
            self.ContactSection = self.cmsRequestFunctions.getAllMapData(
              contactArea[0].component
            );
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
  },
};
</script>

